import { Alert, RiUserLine } from "@itandi/itandi-bb-ui";
import React from "react";
import { useFormContext } from "react-hook-form";
import { TenantBlockBase } from "~/components/common/deals/new/block/TenantBlockBase";
import type { Deal } from "~/models/Deal";
import type { RelatedDealParam } from "~/models/DealForm";
import Styles from "../../../../../../common/deals/new/block/Block.module.scss";

type Props = {
	deal: Deal;
};

export const TenantBlock: React.FC<Props> = ({ deal }: Props) => {
	const { setValue } = useFormContext<RelatedDealParam>();

	React.useEffect(() => {
		setValue("tenantName", deal.tenantName);
		setValue("tenantNameKana", deal.tenantNameKana);
		setValue("tenantTel", deal.tenantTel);
		setValue("tenantEmail", deal.tenantEmail);
	}, [deal, setValue]);

	const hasValue = (value: string | null | undefined): boolean =>
		value !== null && value !== "";
	const isTenantNameDisabled = hasValue(deal.tenantName);
	const isTenantNameKanaDisabled = hasValue(deal.tenantNameKana);
	const isTenantTelDisabled = hasValue(deal.tenantTel);
	const isTenantEmailDisabled = hasValue(deal.tenantEmail);
	const allTenantInfoDisabled =
		isTenantNameDisabled &&
		isTenantNameKanaDisabled &&
		isTenantTelDisabled &&
		isTenantEmailDisabled;
	return (
		<div className={Styles.Block}>
			<div className={Styles.BlockCaptionWrapper}>
				<div className={Styles.BlockCaption}>
					<span className={Styles.BlockIconWrapper}>
						<RiUserLine className={Styles.BlockIcon} />
					</span>
					<span className={Styles.BlockCaptionLabel}>入居者情報</span>
				</div>
			</div>
			<div className={Styles.BlockForms}>
				{!allTenantInfoDisabled && (
					<div className={Styles.FormRow}>
						<div className={Styles.FormContent}>
							<Alert variant="warning">
								ここで入力した入居者情報は、関連する案件全てに反映されます。
								<br />
								施工会社への入居者情報の開示を希望しない案件がある場合は、必ず案件詳細画面で「個人情報公開」のチェックを外してください。
							</Alert>
						</div>
					</div>
				)}
				<TenantBlockBase
					isTenantEmailDisabled={isTenantEmailDisabled}
					isTenantNameDisabled={isTenantNameDisabled}
					isTenantNameKanaDisabled={isTenantNameKanaDisabled}
					isTenantTelDisabled={isTenantTelDisabled}
				/>
			</div>
		</div>
	);
};
